import { merge } from 'lodash'
import api from '@/api'
import notifier from '@/notifier'

export default {
  namespaced: true,
  state: {
    statuses: ['approved', 'pending', 'canceled', 'refunded'],
    expediterStatuses: [],
    items: [],
    total: 0,
    fetching: false,
    filter: {}
  },
  actions: {
    async fetch ({ state, commit }, options) {
      commit('setFetching', true)

      api.getOrderExpediterStatuses()
        .then(statuses => commit('setExpediterStatuses', statuses))
        .catch(() => commit('setExpediterStatuses', []))

      commit('setList', await api.getOrdersList(options))
      commit('setFetching', false)
    },
    async updateInfo ({ state, getters, commit }, { identifier, code, info }) {
      await api.updateOrderInfo(identifier, code, info)
      const order = getters.getByMarketplaceIdentifierAndCode(identifier, code)
      if (order) {
        merge(order, info)
        commit('setItem', order)
      }
    },
    async syncOrder ({ state, commit }, { type, identifier, code }) {
      commit('setItem', await api.syncOrder(type, identifier, code))
    },
    async synchronizeOrderExpediter ({ state, commit }, { type, identifier, code }) {
      try {
        const order = await api.syncOrderExpediter(type, identifier, code)
        notifier.success('Expedição do produto sincronizada!', 'Sincronizado')
        commit('setItem', order)
      } catch (error) {
        commit('setItem', error.response.data)
        notifier.error('Falha ao sincronizar o pedido com o expeditor!', 'Não sincronizado')
      }
    },
    async unlinkOrderFromExpediter ({ state, commit }, { type, orderId, identifierExpediter }) {
      try {
        const order = await api.unlinkOrderExpediter(type, orderId, identifierExpediter)
        notifier.success('Expeditor desvinculado!', 'Sucesso')
        commit('setItem', order)
      } catch (error) {
        commit('setItem', error.response.data)
        notifier.error('Falha ao desvincular pedido com o expeditor!', 'Erro')
      }
    },
    fillFilter ({ state, commit }, filter) {
      commit('setFilter', filter)
    },
    addOrder ({ state, commit }, { identifier, code }) {
      commit('setFetching', true)

      api.getOrder(identifier, code)
        .then(order => commit('addItem', order))
        .catch(() => {})
        .finally(() => commit('setFetching', false))
    }
  },
  getters: {
    getByMarketplaceIdentifierAndCode: state => (identifier, code) => state.items.find(item =>
      item.marketplace.identifier === identifier &&
      item.marketplace.code === code)
  },
  mutations: {
    setFetching (state, fetching) {
      state.fetching = fetching
    },
    setList (state, { items, total }) {
      state.items = items
      state.total = total
    },
    addItem (state, item) {
      state.items.push(item)
    },
    setItem (state, newItem) {
      const item = state.items.find(item => item.id === newItem.id)
      if (item) {
        merge(item, newItem)
      }
    },
    setFilter (state, newFilter) {
      state.filter = newFilter
    },
    setExpediterStatuses (state, statuses) {
      state.expediterStatuses = statuses
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/orders.js